// react, react-redux
import React from "react";
import { connect } from "react-redux";

// helpers
import { leaf } from "../../../helpers/actionsHelpers";
import { formatBytes } from "../../../helpers/renderHelpers";

// styling
import "./ReviewField.scss";

class ReviewField extends React.Component {
  render() {
    const {
      type,
      propertyName,
      title,
      formData,
      attachments,
      arrayPosition,
      format,
      autoWidth,
      listType,
      jumpToPage,
      page
    } = this.props;

    return (
      <div className={`${ type !== 'editButton' ? `review--section-details-wrapper ${autoWidth ? 'autoWidth' : ''}` : ''}`}>
        {type === 'propertyAddress' && formData[propertyName] && (
          <div>
            <h4 className="review--section-details-title">Address</h4>
            <p className="review--section-details-value">
              {formData[propertyName].unitNo}{formData[propertyName].unitNo && (' / ')}{formData[propertyName].streetNo}{" "}
              {formData[propertyName].streetName}{" "}
              {(formData[propertyName].unitNo ||
                formData[propertyName].streetNo ||
                formData[propertyName].streetName) &&
                (formData[propertyName].suburb ||
                  formData[propertyName].state ||
                  formData[propertyName].postcode ||
                  formData[propertyName].country) && <span>,</span>}{" "}
              {formData[propertyName].suburb} {formData[propertyName].state}{" "}
              {formData[propertyName].postcode}
            </p>
          </div>
        )}
        {type === 'contact' && formData[propertyName] && (
          <div>
            <h4 className="review--section-details-title">{title}</h4>
            <p className="review--section-details-value">
              {formData[propertyName].title} {formData[propertyName].givenName}{" "}
              {formData[propertyName].familyName}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName].abn}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName].organisationName}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName].positionTitle}
            </p>
            {formData[propertyName].address && (
              <p className="review--section-details-value">
                {formData[propertyName].address.unitNo}{" "}{formData[propertyName].address.unitNo && (' / ' )}
                {formData[propertyName].address.streetNo}{" "}
                {formData[propertyName].address.streetName}{" "}
                {(formData[propertyName].address.unitNo ||
                  formData[propertyName].address.streetNo ||
                  formData[propertyName].address.streetName) &&
                  (formData[propertyName].address.suburb ||
                    formData[propertyName].address.state ||
                    formData[propertyName].address.postcode ||
                    formData[propertyName].address.country) && <span>,</span>}{" "}
                {formData[propertyName].address.suburb}{" "}
                {formData[propertyName].address.state}{" "}
                {formData[propertyName].address.postcode}{" "}
                {formData[propertyName].address.country}
              </p>
            )}
            <p className="review--section-details-value">
              {formData[propertyName].email}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName].telephone}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName].mobile}
            </p>
          </div>
        )}
        {type === 'contactArray' && formData[propertyName] && (
          <div>
            <h4 className="review--section-details-title">{title}</h4>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].title}{" "}
              {formData[propertyName][arrayPosition].givenName}{" "}
              {formData[propertyName][arrayPosition].familyName}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].abn}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].organisationName}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].positionTitle}
            </p>
            {formData[propertyName][arrayPosition].address && (
              <p className="review--section-details-value">
                {formData[propertyName][arrayPosition].address.unitNo}{" "}{formData[propertyName][arrayPosition].address.unitNo && (' / ' )}
                {formData[propertyName][arrayPosition].address.streetNo}{" "}
                {formData[propertyName][arrayPosition].address.streetName}{" "}
                {(formData[propertyName][arrayPosition].address.unitNo ||
                  formData[propertyName][arrayPosition].address.streetNo ||
                  formData[propertyName][arrayPosition].address.streetName) &&
                  (formData[propertyName][arrayPosition].address.suburb ||
                    formData[propertyName][arrayPosition].address.state ||
                    formData[propertyName][arrayPosition].address.postcode ||
                    formData[propertyName][arrayPosition].address.country) && (
                    <span>,</span>
                  )}{" "}
                {formData[propertyName][arrayPosition].address.suburb}{" "}
                {formData[propertyName][arrayPosition].address.state}{" "}
                {formData[propertyName][arrayPosition].address.postcode}{" "}
                {formData[propertyName][arrayPosition].address.country}
              </p>
            )}
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].email}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].telephone}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].mobile}
            </p>
          </div>
        )}
        {type === 'description' && typeof leaf(formData, propertyName) !== 'undefined' && (
          <div>
            <h4 className="review--section-details-title">{title}</h4>
            <p className="review--section-details-value">
              {format && format !== 'decimals' ? format(leaf(formData, propertyName)) : (
                leaf(formData, propertyName) === 'true' ? 'Yes' : (
                  leaf(formData, propertyName) === 'false' ? 'No' : `${format === 'decimals' ? `$${leaf(formData, propertyName).toLocaleString()}` : leaf(formData, propertyName).charAt(0).toUpperCase() + leaf(formData, propertyName).slice(1)}`
                )
              )}
            </p>
          </div>
        )}
        {type === 'list' && (
          <div>
            { !listType && (
              <div>
                <h4 className="review--section-details-title">{title}</h4>
                <ul className="review--section-details-value review list">
                {formData[propertyName].map(function(item, i) 
                  {
                    return (item.category || item) ?
                      <li key={i} className="list-tile">
                        <div className="list-tile-content">
                          <p className="list-tile-content-name review--section-details-value">
                            {(item.category || item).toUpperCase()}
                          </p>
                        </div>
                      </li>
                      : null
                  }
                )}
                </ul>
              </div>
            )}
            { listType && listType === 'upload' && (
              <div>
                {title && (<h4 className="review--section-details-title">{title}</h4>)}
                <ul className="review review--section-details-value list list-uploadFile">
                  {attachments.map((attachment, i) => 
                    {
                      return attachment.transactionID ?
                        <li key={i} className="list-tile approved">
                          <div className="list-tile-content">
                            <p className="list-tile-content-name review--section-details-value">
                              {attachment.originalFileName} ({formatBytes(attachment.fileSize, 2)})
                            </p>
                            <p className="list-tile-content-name review--section-details-value">
                              {attachment.category} | {attachment.subCategory}
                            </p>
                          </div>
                        </li>
                        : null
                    }
                  )}
                </ul>
              </div>
            )}
          </div>
        )}
        {type === 'paymentReceipt' && formData[propertyName] && (
          <div>
            <h4 className="review--section-details-title">Receipt details</h4>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].type === 'bpay' ? 'BPAY' : null}
            </p>
            <p className="review--section-details-value">
              ${formData[propertyName][arrayPosition].amountPaid}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].bankName}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].receiptNumber}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].receiptDate}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].paymentMethod}
            </p>
            <p className="review--section-details-value">
              {formData[propertyName][arrayPosition].uniqueSequenceNumber}
            </p>
          </div>
        )}
        {type === 'editButton' && (
          <button
            type="button"
            className="sq-form-page-button edit"
            onClick={() => {
              jumpToPage(page);
            }}
          >
            Edit
          </button>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    attachments: state.service.attachments
  };
};

export default connect(mapStateToProps)(ReviewField);  
